"use strict";
exports.__esModule = true;
exports.EARLY_PAY_FLEX_ANYWHERE_PAYMENT_SCHEDULE = exports.FLEX_ANYWHERE_PAYMENT_SCHEDULE = void 0;
exports.FLEX_ANYWHERE_PAYMENT_SCHEDULE = {
    HEADER: 'Payment schedule for {{month}}',
    BODY: 'Based on your ${{rentAmount}} rent, here’s how you’ll pay Flex.',
    TABLE_TITLE: 'Payments to Flex',
    CTA: 'Accept'
};
exports.EARLY_PAY_FLEX_ANYWHERE_PAYMENT_SCHEDULE = {
    HEADER: 'Payment schedule for {{month}}',
    BODY: 'Here’s how you’ll pay Flex this month so we can approve your rent transaction of ${{rentAmount}}.',
    TABLE_TITLE: 'Payments to Flex',
    CTA: 'Next'
};
